import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabela-prospeccao',
  templateUrl: './tabela-prospeccao.component.html',
  styleUrls: ['./tabela-prospeccao.component.scss']
})
export class TabelaProspeccaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
